import React from 'react';
import { useDispatch } from 'react-redux';
import { ReactSVG } from 'react-svg';

import { editContent } from '../../modules/editor';
import { getPathAfterBuild } from '../../util/file';

type ButtonGroupProps = {
	target: string;
	value: string;
	options: any[];
	imagePath?: string;
	imageType?: string;
	default?: string;
	disabled?: boolean;
};

function ButtonGroup({ target, value, options, imagePath, imageType, disabled }: ButtonGroupProps) {
	const dispatch = useDispatch();

	const iconImage = (path) => {
		const context = require.context('../../assets/images/', true);
		return getPathAfterBuild(context, path);
	};

	const onClick = (item: any) => {		
		const { value } = item;
		dispatch(editContent({ target: target, data: value }));
	}

	return (
		<div className="btn-group">
			{
				options.map((item:any, index:number) => (
					<button 
						key={index}
						className={disabled ? 'btn disabled' : (item.value === value ? 'btn active' : 'btn')}
						onClick={() => (onClick(item))} 
					>
						{
							imageType === 'svg' ? (
								<ReactSVG src={iconImage(`./${imagePath}${item.value}.${imageType}`)} height="16" />
							) : (
								<img src={iconImage(`./${imagePath}${item.value}.${imageType}`)} height="16" />
							)
						}
					</button>
				))
			}
		</div>
	);
}

ButtonGroup.defaultProps = {
	imageType: 'png'
};

export default ButtonGroup;